<template>
  <v-container v-if="$can('browse', 'roles')">
    <!--<editor-fold desc="Page header">-->
    <v-row

      align="center"
      class="mb-6"
    >
      <v-col>
        <div class="headline">
          Roles
        </div>
      </v-col>
      <v-col class="shrink">
        <v-btn
          v-if="$can('create', 'roles')"
          color="primary"
          class="ma-0"
          @click="openRoleEditDialog()"
        >
          <v-icon left>
            add
          </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>
    <!--</editor-fold>-->

    <v-row>
      <v-col
        cols="3"
      >
        <v-subheader class="justify-space-between pr-0">
          Filters
          <v-btn
            v-if="isFiltered"
            text
            color="red"
            @click="clearFilters"
          >
            <v-icon
              small
              left
            >
              close
            </v-icon>
            Clear
          </v-btn>
        </v-subheader>
        <v-text-field
          v-model="filtersDirty.title"
          label="Title"
          solo
          clearable
          hide-details
          class="mb-2"
        />
      </v-col>
      <v-col cols="13">
        <!--<editor-fold desc="Pagination header">-->
        <pagination
          :from="roles.meta.from"
          :to="roles.meta.to"
          :total="roles.meta.total"
          :last-page="roles.meta.last_page"
          :page.sync="pagination.page"
          class="mb-1 align-end"
        />
        <!--</editor-fold>-->
        <!--<editor-fold desc="Table">-->
        <v-data-table
          :headers="headers"
          :items="roles.data"
          :loading="roles.loading"
          :page.sync="pagination.page"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.desc"
          :server-items-length="roles.meta.total"
          hide-default-footer
          must-sort
          class="elevation-5"
        >
          <template v-slot:item="{ item }">
            <role-row
              :role="item"
              @click.native="openRoleEditDialog(item)"
            />
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <v-row
              v-if="isFiltered"

              class="text-center py-2"
            >
              <v-col cols="16">
                There are no results for your search..
              </v-col>
              <v-col
                cols="16"
                class="mt-2"
              >
                <v-btn
                  class="ma-0"
                  small
                  text
                  color="default"
                  @click="clearFilters()"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </v-col>
            </v-row>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <v-row
              v-else

              class="text-center py-2"
            >
              <v-col cols="16">
                There are no roles at the moment.
              </v-col>
              <v-col
                cols="16"
                class="mt-2"
              >
                <v-btn
                  color="primary"
                  class="ma-0"
                  small
                  @click="openRoleEditDialog()"
                >
                  <v-icon left>
                    add
                  </v-icon>
                  Add New
                </v-btn>
              </v-col>
            </v-row>
            <!--</editor-fold>-->
          </template>
          <table-footer
            slot="footer"
            :last-page="roles.meta.last_page"
            :page.sync="pagination.page"
          />
        </v-data-table>
        <!--</editor-fold>-->
      </v-col>
    </v-row>

    <role-edit-dialog
      :visible.sync="roleEditDialog"
      :role="roleDirty"
      :roles="roles.data"
      @role:created="roleCreated"
      @role:updated="roleUpdated"
    />
  </v-container>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import paginationMixin from '@/mixins/paginationMixin'
  import filterableMixin from '@/mixins/filterableMixin'
  import Role from '@/models/Role'
  import RoleRow from '@/components/settings/roles/RoleRow'
  import RoleEditDialog from '@/components/settings/roles/RoleEditDialog'
  import TableFooter from '@/components/helpers/TableFooter'

  export default {
    name: 'RolesIndex',
    components: {
      RoleRow,
      RoleEditDialog,
      TableFooter
    },
    mixins: [paginationMixin, filterableMixin],
    data() {
      return {
        roles: {
          data: [],
          loading: false,
          meta: {}
        },
        headers: [
          { text: '#', value: 'id', sortable: true },
          { text: 'Title', value: 'title', sortable: true }
        ],
        roleDirty: null,
        roleEditDialog: false,
        filtersClean: cloneDeep(Role.emptyFilters),
        filtersDirty: cloneDeep(Role.emptyFilters)
      }
    },
    created() {
      this.fetchRoles()
    },
    methods: {
      onPaginationUpdate: function() {
        this.fetchRoles()
      },
      onFiltersUpdate: function() {
        this.resetPagination()
      },
      fetchRoles: async function() {
        this.roles.loading = true

        let queryParams = {
          ...this.paginationQueryParams,
          ...this.filterQueryParams
        }

        try {
          let result = await Role.api.fetch(queryParams)
          this.roles.data = result.data
          this.roles.meta = result.meta
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.roles.loading = false
        }
      },
      openRoleEditDialog: function(role = undefined) {
        this.roleDirty = cloneDeep(role)
        this.roleEditDialog = true
      },
      roleCreated: function(role) {
        this.roles.data.unshift(role)
      },
      roleUpdated: function(role) {
        const index = this.roles.data.findIndex(r => r.id === role.id)

        this.roles.data.splice(index, 1, role)
      }
    }
  }
</script>
